import React from 'react'

const Rating = () => {
  return (
    <div>Rating</div>
  )
}

export default Rating